var productIntro = {
  init: function init() {
    productIntro.setupCarousel();
    productIntro.bindAddToCartBtnClickEvent();
    productIntro.bindPlusMinusEvent();
  },
  setupCarousel: function setupCarousel() {
    var moreThanOneImage = $(".productIntro-carouselCell img").length > 1;
    $('.productIntro-carousel').flickity({
      arrowShape: 'M70.5 99.3L21.2 50 70.5.7 76 6.2 32.2 50 76 93.8z',
      lazyLoad: true,
      prevNextButtons: moreThanOneImage,
      pageDots: moreThanOneImage
    });
  },
  addToCartCallback: function addToCartCallback(data) {
    if (updateVisualCartIcon) {
      updateVisualCartIcon(data);
    }
  },
  bindPlusMinusEvent: function bindPlusMinusEvent() {
    $(".productIntro-plus").on("click", function () {
      var oldVal = $(".productIntro-quantity").val();
      if (oldVal.length < 1) {
        oldVal = "0";
      }
      $(".productIntro-quantity").val(parseInt(oldVal) + 1);
    });
    $(".productIntro-minus").on("click", function () {
      var oldVal = $(".productIntro-quantity").val();
      if (oldVal.length < 1) {
        oldVal = "0";
      }
      $(".productIntro-quantity").val(parseInt(oldVal) - 1);
    });
  },
  bindAddToCartBtnClickEvent: function bindAddToCartBtnClickEvent() {
    $("[data-action=addtocart]").on("click", function () {
      var addToCartButton = $(this);
      $(addToCartButton).prop("disabled", true);
      var sitecoreItem = $("body").data("sc-item"),
        sitecoreLanguage = $("body").data("sc-language"),
        sku = $(this).data("sku"),
        name = $(this).data("name"),
        price = $(this).data("price"),
        quantity = $(".productIntro-quantity").val();
      if (quantity === undefined) {
        quantity = 1;
      }
      if (quantity > 0) {
        ga4TagEcommerceHelper.measureAddToCart({
          'name': name,
          'id': sku,
          'price': price,
          'brand': 'N/A',
          'category': 'N/A',
          'variant': 'N/A',
          'quantity': quantity
        });
        $.ajax({
          type: "POST",
          url: "/post-add-sku-to-cart",
          data: {
            "skupimid": $(this).data("skuid"),
            "modelpimid": $(this).data("modelid"),
            "quantity": quantity,
            sitecoreLanguageName: sitecoreLanguage,
            sitecoreItemId: sitecoreItem
          },
          success: function success(result) {
            productIntro.addToCartCallback(result);
            $(addToCartButton).prop("disabled", false);
          }
        });
      } else {
        $(addToCartButton).prop("disabled", false);
      }
    });
  }
};
$(function () {
  productIntro.init();
});